<template>
  <div class="logistics">
    <div class="log">
      <div class="hander">
        <span>物流信息</span>
      </div>
      <ul>
        <li v-for="(item,index) in logs" :key="item.AcceptTime">
          <div class="left">
            <div class="t1">{{ item.AcceptTime[1] }}</div>
            <div class="t2">{{ item.AcceptTime[0] }}</div>
            <div class="line" :class="index == 0 && 'on'" v-if="index!==logs.length -1"></div>
          </div>
          <p class="text">{{ item.AcceptStation }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props:['logs']
}
</script>

<style lang="less" scoped>
.logistics {
  .log {
    .hander {
      width: 100%;
      height: 100px;
      background: #fff;
      margin-top: 20px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        height: 98px;
        line-height: 98px;
        padding: 0 15px;
        margin: 0;
        font-size: 30px;
        color: #333;
        border-bottom: 2px solid #e42129;
      }
    }
    ul {
      padding: 20px 0;
      background-color: #fff;
      li {
        display: flex;
        // align-items: center;
        height: 210px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 24px;
        .left {
          display: flex;
          flex-direction: column;
          align-items: center;
          // width: 170px;
          height: 210px;
          .t1 {
            font-size: 32px;
            color: #333;
          }
          .t2 {
            font-size: 22px;
            color: #666;
          }
          .line {
            width: 2px;
            height: 80px;
            background: #666;
          }
          .on{
            background-color: #e42129;
          }
        }
        .text {
          flex: 1;
          margin-left: 16px;
          font-size: 26px;
        }
      }
    }
  }
}
</style>
